import { Component, OnInit } from '@angular/core';

import { GeopointsService } from '../../services/geopoints.service';
import { MapServicesService } from '../../../map/services/map-services.service';

import { PanelService } from '../../../panel/services/panel.service';

import Swal from 'sweetalert2';
import * as L from 'leaflet';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-list-geopoints',
  templateUrl: './list-geopoints.component.html',
  styleUrls: ['./list-geopoints.component.scss']
})
export class ListGeopointsComponent implements OnInit {

  datosCargados = false;
  NomBusqueda = "";

  noResults: boolean = false;

  constructor(
    public geopointsService: GeopointsService,
    public mapService: MapServicesService,
    public panelService: PanelService,

  ) {}

  ngOnInit(): void {
    if(!this.geopointsService.initializingGeopoints || !this.geopointsService.initializingUserPrivleges){
      this.geopointsService.spinner.show('loadingGeopointsSpinner');
    }
    //this.mostrar_tabla();
  }

  /* mostrar_tabla() {
    let geos = this.geopointsService.getData();
    console.log(geos);

    this.tblDataGeo = [];

    for (let i = 0; i < geos.length; i++) {
      geos[i].geopunto_nombre_visible_bol = (geos[i].geopunto_nombre_visible === 'true');
      geos[i].geopunto_visible_bol = (geos[i].geopunto_visible === 'true');


      this.tblDataGeo.push({trama:geos[i]});
    }
    // this.tblDataGeo.push({icono:"assets/images/end.png", trama:dH[dH.length-1],icono_width:"13px",icono_height:"13px"});
  } */

  clickLocate(id:number){
    console.log("localizar un GEOPUNTO");
    console.log(id);
    var geo = this.geopointsService.geopoints.filter((item:any)=> item.geopunto_id == id)[0];
    console.log(geo);
    console.log(geo.geo_elemento.getLatLng());

    // var latlng = this.geopoints[i].geopunto_vertices.split(",")
    //bounds.push([parseFloat(latlng[0]), parseFloat(latlng[1])]);

    this.mapService.map.fitBounds([geo.geo_elemento.getLatLng()], {
      padding: [50, 50]
    });
  }


  clickShow(id:number, comesFromInputSwitch?: boolean){
    //console.log("localizar una geo punto");
    //console.log(id);

    var geo = this.geopointsService.geopoints.filter((item:any)=> item.geopunto_id == id)[0];

    console.log(geo);

    if (geo.geopunto_visible == "true") {

      geo.geopunto_visible  = "false";
      this.mapService.map.removeLayer(geo.geo_elemento);


      if(geo.geopunto_nombre_visible == 'true'){
        this.clickShowNameGeocerca(id);
      }
    } else {

      geo.geopunto_visible  = "true";
      geo.geo_elemento.addTo(this.mapService.map);

      /* if(geo.geopunto_nombre_visible == 'false'){
        this.clickShowNameGeocerca(id);
      } */
    }

    this.geopointsService.updateGeoCounters();
    this.geopointsService.updateGeoTagCounters();

    if(typeof comesFromInputSwitch == 'undefined' || !comesFromInputSwitch){
      this.geopointsService.eyeInputSwitch = this.geopointsService.geopointCounters.visible != 0;
    }

  }

  clickShowNameGeocerca(id:number, comesFromInputSwitch?: boolean){
    //console.log("Mostrar/Ocultar nombre");
    var geo = this.geopointsService.geopoints.filter((item:any)=> item.geopunto_id == id)[0];

    /* console.log("LITGEO",geo); */

    if (geo.geopunto_nombre_visible == "true") {

      geo.geopunto_nombre_visible  = "false";
      geo.geopunto_nombre_visible_bol = false;

      this.mapService.map.removeLayer(geo.marker_name);
    } else {

      geo.geopunto_nombre_visible  = "true";
      geo.geopunto_nombre_visible_bol = true;

      geo.marker_name.addTo(this.mapService.map);
    }

    this.geopointsService.updateGeoTagCounters();

    if(typeof comesFromInputSwitch == 'undefined' || !comesFromInputSwitch){
      this.geopointsService.tagNamesEyeState = this.geopointsService.geopointTagCounters.visible != 0;
    }

  }

  clickConfigurarGeopunto(id:number) {
    console.log('clickConfigurarGeocerca');
    this.geopointsService.nombreComponente = "AGREGAR";
    console.log(id);
    this.geopointsService.action         = "edit";
    this.geopointsService.idGeopointEdit = id;



  }

  clickEliminarGeopunto(event:any, id:number) {
    console.log('clickEliminarGeopunto');
    console.log(id);
    this.geopointsService.action = "delete";

    event.preventDefault();
    var geo = this.geopointsService.geopoints.filter((item:any)=> item.geopunto_id == id)[0];


    Swal.fire({
        title: '¿Está seguro?',
        text: `¿Está seguro que desea eliminar ${geo.geopunto_name}?`,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        preConfirm:async () => {
          const res = await this.geopointsService.delete(id);
          // this.deleteAlert.emit();
          // this.clickShowPanel(this.nameComponent);

          this.mapService.map.removeLayer(geo.geo_elemento);
          this.mapService.map.removeLayer(geo.marker_name);

          for (var i = 0; i < this.geopointsService.geopoints.length; i++) {
            if (this.geopointsService.geopoints[i].geopunto_id === id) {
              this.geopointsService.geopoints.splice(i, 1);
              i--;
            }
          }
          //this.mostrar_tabla();
          this.geopointsService.initializeTable();
          this.geopointsService.updateGeoCounters();
          this.geopointsService.updateGeoTagCounters();
          this.geopointsService.eyeInputSwitch = this.geopointsService.geopointCounters.visible != 0;
          this.geopointsService.tagNamesEyeState = this.geopointsService.geopointTagCounters.visible != 0;
          this.onBusqueda();

        }
    }).then(data => {
      if(data.isConfirmed){
        Swal.fire(
          'Eliminado',
          'Los datos se eliminaron correctamente!!',
          'success'
        );
      }
    });


  }

  clickAgregarGeopunto() {
    this.geopointsService.nombreComponente = "AGREGAR";
    this.geopointsService.action         = "add";

  }

  onBusqueda(gaaa?:any) {
    if(this.NomBusqueda == ''){
      this.geopointsService.tblDataGeoFiltered = this.geopointsService.getTableData();
      this.noResults = false;
    } else {
      const normalizedSearch = this.NomBusqueda.normalize('NFKD')
        .replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ0-9 -_.@#]+/g, '')
        .toUpperCase();

      this.geopointsService.tblDataGeoFiltered = this.geopointsService.getTableData().filter((geopunto: any) => {
        const geopuntoName = geopunto.trama.geopunto_name
          ? geopunto.trama.geopunto_name.normalize('NFKD').replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ0-9 -_.@]+/g, '').toUpperCase()
          : '';

        const geopuntoColor = geopunto.trama.geopunto_color
          ? geopunto.trama.geopunto_color.toUpperCase()
          : '';

        return (
          geopuntoName.includes(normalizedSearch) ||
          geopuntoColor.includes(normalizedSearch)
        );
      });

      // this.geopointsService.tblDataGeoFiltered = this.geopointsService.getTableData().filter( (geopunto: any) => {
      //   return geopunto.trama.geopunto_name != null && geopunto.trama.geopunto_name.normalize('NFKD').replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ0-9 -_.@]+/g, '').toUpperCase().includes(this.NomBusqueda.normalize('NFKD').replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚäëïöüÄËÏÖÜ0-9 -_.@]+/g, '').toUpperCase());
      // });
      this.noResults = this.geopointsService.tblDataGeoFiltered.length == 0;
    }
  }

  onClickEye(){
    console.log('Click All EYE');
    if(this.NomBusqueda.trim() != ''){
      console.log('Solo Ocultar Geopuntos Filtrados...');
      console.log('This eyeInputSwitch : ',this.geopointsService.eyeInputSwitch);
      this.geopointsService.getTableFilter().forEach((geopoint) => {
        if((geopoint.trama.geopunto_visible == 'true') != this.geopointsService.eyeInputSwitch){
          console.log('Geo: ',geopoint.trama.geopunto_id);
          this.clickShow(geopoint.trama.geopunto_id,true);
        }
      });
    }else{
      var geopointsList = this.geopointsService.geopoints.map( (geopoint: { geopunto_id: number, geopunto_visible: string }) =>
        { return { id: geopoint.geopunto_id, visible: geopoint.geopunto_visible}; } );
      geopointsList.forEach((geopoint: { id: number, visible: string }) => {
        if((geopoint.visible == 'true') != this.geopointsService.eyeInputSwitch){
          this.clickShow(geopoint.id, true);
        }
      });
    }

  }

  onClickTagNamesEye(){
    this.geopointsService.tagNamesEyeState = !this.geopointsService.tagNamesEyeState;
    var geopointsList = this.geopointsService.geopoints.map( (geopoint: { geopunto_id: number, geopunto_nombre_visible: string }) =>
      { return { id: geopoint.geopunto_id, tag_visible: geopoint.geopunto_nombre_visible}; } );
    geopointsList.forEach((geopoint: { id: number, tag_visible: string }) => {
      if((geopoint.tag_visible == 'true') != this.geopointsService.tagNamesEyeState){
        this.clickShowNameGeocerca(geopoint.id, true);
      }
    });
  }

}
